<template>
    <div class="position-relative">
        <transition name="vue-table-loader">
            <div class="vue-table-loader" v-if="loading"><span class="fa fa-cog fa-spin fa-3x"></span></div>
        </transition>

        <div class="row">
            <div class="col-md-4">
                <base-filter-bar placeholder="Search Entity Relation Types"></base-filter-bar>
            </div>
            <div class="col-md-8">
                <base-select-visible :per-page="perPage" :amounts-shown="amountsShown"></base-select-visible>
            </div>
        </div>
        <div class="dataTables_wrapper container-fluid dt-bootstrap4 modern">
            <vuetable ref="vuetable"
                :api-url="url"
                :fields="fields"
                :css="css.table"
                :per-page="perPage"
                :append-params="moreParams"
                noDataTemplate="No Entity Relation Types Found"
                pagination-path=""
                @vuetable:pagination-data="onPaginationData"
                @vuetable:loaded="onLoaded"
            >
                <template slot="name" slot-scope="props">
                        <a class="" :href="'/entity-relation-types/' + props.rowData.id + '/edit/'"><strong>{{ props.rowData.name }}</strong></a>
                </template>

                <template slot="actions" slot-scope="props">
                        <a class="btn btn-outline-primary" :href="'/entity-relation-types/' + props.rowData.id + '/edit/'">View</a>
                </template>

            </vuetable>
            <div class="row">
                <div class="col-md-6">
                    <base-pagination-info
                        :css="css.table"
                        ref="paginationInfo"
                    >
                    </base-pagination-info>
                </div>
                <div class="col-md-6">
                    <base-pagination  ref="pagination"
                      @vuetable-pagination:change-page="onChangePage"
                    ></base-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .w195{
        width: 195px;
    }
    .w120{
        width: 120px;
    }
    .w155{
        width: 155px;
    }
</style>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host

    import Vue from 'vue';
    import VueEvents from 'vue-events'
    import * as Vuetable from 'vuetable-2';
    import moment from 'moment';
    import BaseFilterBar from './base-filter-bar.vue';
    import BasePagination from './base-pagination.vue';
    import BasePaginationInfo from './base-pagination-info.vue';
    import BaseSelectVisible from './base-select-visible.vue';

    Vue.use(VueEvents)

    export default {
        name: 'EntityRelatedTypesListing',
        props: [],
        components:{
            'base-filter-bar': BaseFilterBar,
            'base-pagination': BasePagination,
            'base-pagination-info': BasePaginationInfo,
            'base-select-visible': BaseSelectVisible,
        },
        data() {
            return {
                perPage: 10,
                moreParams: {},
                selected: null,
                loading: true,
                fields: [
                    {
                        name: '__slot:name',
                        title: 'Name',
                        sortField: 'name',
                    },
                    {
                        name: 'description',
                        sortField: 'description',
                    },
                    {
                        name: '__slot:actions',
                        titleClass: 'actions-single-column',
                    },
                ],
                amountsShown: [
                    { text: '10', value: 10 },
                    { text: '25', value: 25 },
                    { text: '50', value: 50 },
                    { text: '100', value: 100 }
                ],
                url: base_url + "/pimapi/concrete-entity-related-types/grid",
                css: {
                    table: {
                        tableClass: 'table table-striped table-bordered table-middle',
                        ascendingIcon: 'sort-icon-asc',
                        descendingIcon: 'sort-icon-desc',
                        infoClass: '',
                    },
                }
            }
        },
        mounted() {
            this.$events.$on('per-page', eventData => this.doVisibleSet(eventData))
            this.$events.$on('filter-set', eventData => this.onFilterSet(eventData))
            this.$events.$on('filter-reset', e => this.onFilterReset())
        },
        watch: {
            'perPage' (val, oldVal) {
              this.$nextTick(function() {
                    this.$refs.vuetable.refresh()
              })
            },
        },
        methods: {
            onPaginationData (paginationData) {
                this.$refs.pagination.setPaginationData(paginationData)
                this.$refs.paginationInfo.setPaginationData(paginationData)
            },
            onChangePage (page) {
                this.$refs.vuetable.changePage(page)
            },
            editRow(rowData){
                console.log(rowData);
            },
            doVisibleSet (perPageValue) {
                this.perPage = perPageValue;
                Vue.nextTick( () => this.$refs.vuetable.refresh())
            },
            onFilterSet (filterText) {
                this.moreParams = {
                    'filter': filterText
                }
                Vue.nextTick( () => this.$refs.vuetable.refresh())
            },
            onFilterReset () {
                this.moreParams = {}
                Vue.nextTick( () => this.$refs.vuetable.refresh())
            },
            onLoaded: function () {
                this.loading = false;
            }
        }
    };
</script>